import React, { useState } from 'react';
import { FaExchangeAlt, FaSpinner } from 'react-icons/fa';
import { useUserPreferences } from '../context/UserPreferencesContext';

// Ticket 77: lets an admin move between the old tile grid and the new stats dashboard themselves,
// rather than waiting on an environment change. The choice is theirs alone — one person trying the new
// one does not move anybody else.
//
// Deliberately a quiet text link, not a button. It is a one-off preference, not something anyone needs
// to act on every visit, so it should sit out of the way of the actual work on the page. It appears on
// both dashboards, so neither side is a trap.

const DashboardSwitch = ({ current, className = '' }) => {
  const { setDashboardVersion } = useUserPreferences();
  const [switching, setSwitching] = useState(false);

  const target = current === 'new' ? 'old' : 'new';
  const label = target === 'new' ? 'Try the new dashboard' : 'Switch to the old dashboard';

  return (
    <button
      type="button"
      disabled={switching}
      onClick={() => { setSwitching(true); setDashboardVersion(target); }}
      title={`Switch your account to the ${target === 'new' ? 'new' : 'old'} dashboard. Only you see the change.`}
      className={`inline-flex items-center gap-2 text-sm text-gray-500 hover:text-jims-cyan-dark
        disabled:opacity-60 rounded px-2 py-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-jims-cyan ${className}`}
    >
      {switching ? <FaSpinner className="animate-spin" /> : <FaExchangeAlt />}
      {switching ? 'Switching…' : label}
    </button>
  );
};

export default DashboardSwitch;
